/**
 * @deprecated Use ClientDiscount instead
 */
export interface Discount {
    id: number
    percent: number
    flat: number
    max_amount: number
    is_unlimited_by_session_count: boolean
    price_limit: number | null
    type: "deposit" | "retail-promo-code" | "b2b-promo-code" | "b2b"
}

export enum ClientDiscountGroup {
    referralProgram = "referral_program",
    abonements = "abonements",
}

export interface ClientDiscount {
    discount_id: number
    discount_name: string
    end_day: string
    price_limit: number | null
    reminder_deposit: number | null
    reminder_usages: number | null
    disabled_by_balance: boolean | null
    session_number_limit_from: number | null
    session_number_limit_to: number | null
    promo_code: string | null
    last_used_at: string | null
    percent: number
    flat: number
    deposit_mode: boolean
    group: ClientDiscountGroup
    month: number
    monthly_reminder_usages: number
    can_be_applied: boolean
}
